import React from "react";
import "../manage_users.css";

type Props = {
  isOpen: boolean;
  deleteStep: number;
  selectedUserName: string;
  selectedUserEmail?: string | null;
  returnedCredits: number;
  error?: string;
  isDeleting?: boolean;
  onClose: () => void;
  onConfirmDelete: () => void;
  onResetStep: () => void;
  formatNumber: (value?: number | null) => string;
};

const DeleteUserModal: React.FC<Props> = ({
  isOpen,
  deleteStep,
  selectedUserName,
  selectedUserEmail,
  returnedCredits,
  error,
  isDeleting,
  onClose,
  onConfirmDelete,
  onResetStep,
  formatNumber,
}) => {
  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
    onResetStep();
  };

  return (
    <div className="popup-overlay" onClick={handleClose}>
      <div
        className="popup-box"
        style={{
          backgroundImage: "url('/images/popup-back.png')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "inherit",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {deleteStep === 1 && (
          <div className="d-flex flex-row justify-content-between">
            <p className="user-info">Delete User</p>
            <img
              src="/images/cancel.png"
              alt="close"
              style={{ cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
        )}

        {deleteStep === 1 && (
          <>
            {error && <div className="email-alert-danger mt-2">{error}</div>}

            <div className="mt-3">
              <p className="permanently">
                Are you sure you want to permanently delete <strong>{selectedUserName}</strong> ({selectedUserEmail || "-"})?
              </p>
              <p className="invitationaction">Deleting this user will:</p>
            </div>

            <div className="mt-3">
              <div className="d-flex flex-row ">
                <div>
                  <span className="pricing-point-icon" aria-hidden="true"></span>
                </div>
                <div>
                  <p className="remove">Remove access immediately</p>
                </div>
              </div>

              <div className="d-flex flex-row ">
                <div>
                  <span className="pricing-point-icon" aria-hidden="true"></span>
                </div>
                <div>
                  <p className="remove">Reclaim unused credits back to the pool</p>
                </div>
              </div>

              <div className="d-flex flex-row ">
                <div>
                  <span className="pricing-point-icon" aria-hidden="true"></span>
                </div>
                <div>
                  <p className="remove">Delete user activity history from reports</p>
                </div>
              </div>
            </div>

            <div className="d-flex flex-row justify-content-between mt-2">
              <div>
                <button type="button" className="cancel" onClick={handleClose}>
                  Cancel
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="saved-delete"
                  disabled={isDeleting}
                  onClick={onConfirmDelete}
                >
                  {isDeleting ? "Deleting..." : "Delete"}
                </button>
              </div>
            </div>
          </>
        )}

        {deleteStep === 2 && (
          <>
            <div className="d-flex flex-row justify-content-end">
              <img
                src="/images/cancel.png"
                alt="close"
                style={{ cursor: "pointer" }}
                onClick={handleClose}
              />
            </div>
            <div className="delete-success">
              <img src="/images/shadow-check.png" className="invitation-img success-icon" alt="" />

              <p className="invitation delete-success-title">{selectedUserName} has been successfully deleted.</p>

              <div className="mt-3">
                <div className="d-flex flex-row ">
                  <div>
                    <span className="pricing-point-icon" aria-hidden="true"></span>
                  </div>
                  <div>
                    <p className="remove">{formatNumber(returnedCredits)} credits returned to account pool.</p>
                  </div>
                </div>

                <div className="d-flex flex-row ">
                  <div>
                    <span className="pricing-point-icon" aria-hidden="true"></span>
                  </div>
                  <div>
                    <p className="remove">User removed from system.</p>
                  </div>
                </div>
              </div>

              <div className="d-flex flex-row justify-content-center mt-2">
                <button type="button" className="f-confirm" onClick={handleClose}>
                  Close
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DeleteUserModal;
